import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { FormattedMessage, useTranslator } from '@jutro/locale';

import metadata from './MLAddressChangeTypePopup.metadata.json5';
import messages from './MLAddressChangeTypePopup.messages';
import styles from './MLAddressChangeTypePopup.module.scss';

const MLAddressChangeTypePopup = (props) => {
    const {
        isAgent,
        MLQBPath,
        startNewQuote,
        setIsPolicyAddressEditable,
        onCancel
    } = props;

    const translator = useTranslator();   
    const [changeType, setChangeType] = useState(undefined);

    const writeValue = useCallback((value) => {
        setChangeType(value);
    }, []);

    const newProperty = useCallback(() => {
        onCancel();
        startNewQuote();
    }, [onCancel, startNewQuote]);

    const addressCorrection = useCallback(() => {
        setIsPolicyAddressEditable(true);
        onCancel();
    }, [setIsPolicyAddressEditable, onCancel]);

    const overrides = {
        startNewQuoteMessageAgent: {
            visible: (changeType === true) && isAgent,
            content: <FormattedMessage
                {...messages.startNewQuoteForNewProperty}
                values={{
                    strongSpan: <strong>{translator(messages.startNewQuote)}</strong>
                }}
            />
        },
        startNewQuoteMessageCustomer: {
            visible: (changeType === true) && !isAgent,
            content: <FormattedMessage
                {...messages.contactYourAgentOrCallUs}
                values={{
                    strongSpan: <strong>{translator(messages.startNewQuote)}</strong>
                }}
            />
        },
        changeTypeRadioBtn: {
            value: changeType
        },
        startNewQuoteBtnAgent: {
            visible: (changeType === true) && isAgent,
            onClick: newProperty
        },
        startNewQuoteLinkCustomer: {
            visible: (changeType === true) && !isAgent,
            href: MLQBPath
        },
        continueBtn: {
            visible: !changeType,
            disabled: changeType === undefined,
            onClick: addressCorrection
        },
        cancelBtn: {
            visible: changeType === true
        },
    };

    overrides.footer = {
        className: cx(isAgent ? styles.footer : styles.ampFooter,  "col-md-12")
    }

    const resolvers = {
        resolveCallbackMap : {
            writeValue,
            onCancel
        },
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
};

MLAddressChangeTypePopup.propTypes = {
    isAgent: PropTypes.bool.isRequired,
    MLQBPath: PropTypes.string.isRequired,
    startNewQuote: PropTypes.func.isRequired,
    setIsPolicyAddressEditable: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};

export default MLAddressChangeTypePopup;
